import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormEditorBase } from './../../../../../models/forms/formEditor.base';

@Component({
  selector: 'swb-textarea',
  templateUrl: './textarea.component.html'
})
export class TextareaComponent extends FormEditorBase implements OnInit {

  public expanded: boolean;
  public empty = false;

  ngOnInit() {
    this.empty = this.control.value.toString().trim().length === 0;
    this.expanded = !this.empty;
  }

  public expand(): void {
    this.expanded = true;
  }

  public shrink(): void {
    this.empty = this.control.value.trim().length === 0;

    if (this.empty) {
      this.expanded = false;
    }
  }

}
